import ApiService from "./ApiService";
import store from "@/store"

const SubscriptionService = {
    getSubscription() {
        return new Promise((resolve, reject) => {
            ApiService.getWithAuth('/subscription').then((response) => {
                // save subscription data to store
                store.dispatch('setSubscription', response.data.data);
                resolve(response);
            }).catch((error) => {
                store.dispatch('setSubscription', null);
                reject(error);
            });
        })
    },
    getPlans() {
        return new Promise((resolve, reject) => {
            ApiService.getWithAuth('/plans').then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    createSubscription(data) {
        return new Promise((resolve, reject) => {
            ApiService.post('/subscription/create', data).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    deleteSubcription() {
        return new Promise((resolve, reject) => {
            ApiService.delete('/subscription/delete').then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    changePlan(planId) {
        return new Promise((resolve, reject) => {
            ApiService.put('/subscription/change-plan', { plan_id: planId }).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        })
    },
    createStripeCustomerSession() {
        return new Promise((resolve, reject) => {
            ApiService.post('/stripe/create_customer_session').then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(null);
                }
            }).catch((error) => {
                reject(error);
            });
        })
    },
};

export default SubscriptionService
